import {css, cx as addStyles} from '@emotion/css';
import {formatValueToDollar} from '@remoov/functional';
import {Button, theme} from '@remoov/remoov-components';
import React, {HTMLAttributes} from 'react';
import {DashboardCard, textBaseStyle} from './Common';

export type CashOutCardProps = {
  previousPaidPrice: Maybe<number>;
  balanceOwedPrice: Maybe<number>;
  openModal?: () => unknown;
};

export const CashOutCard = ({previousPaidPrice, balanceOwedPrice, openModal}: CashOutCardProps) => {
  const totalAmount = (balanceOwedPrice || 0) + (previousPaidPrice || 0);
  return (
    <DashboardCard>
      <Title>Total amount of all items sold:</Title>
      <Value>{formatValueToDollar(totalAmount, {maximumFractionDigits: 2})}</Value>
      <Title>Total amount previous paid out:</Title>
      <Value>{formatValueToDollar(previousPaidPrice || 0, {maximumFractionDigits: 2})}</Value>
      <Title>Remaining balance owed to you:</Title>
      <Value>{formatValueToDollar(balanceOwedPrice || 0, {maximumFractionDigits: 2})}</Value>
      <ButtonContainer>
        <Button
          buttonStyle='primary'
          disabled={balanceOwedPrice ? balanceOwedPrice <= 0 : true}
          onClick={openModal}
        >
          Cash Out
        </Button>
      </ButtonContainer>
    </DashboardCard>
  );
};
const Title = (args: HTMLAttributes<HTMLParagraphElement>) => (
  <p className={textBaseStyle} {...args} />
);
const Value = (args: HTMLAttributes<HTMLParagraphElement>) => (
  <p
    className={addStyles(
      textBaseStyle,
      css({
        color: theme.colors.darkBlue,
        fontSize: theme.font.sizes.medium,
        fontWeight: theme.font.bold,
        [`& + p`]: {marginTop: theme.spacings.xsmall},
      }),
    )}
    {...args}
  />
);
const ButtonContainer = (args: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={css({marginTop: theme.spacings.medium, [theme.mediaMaxWidth.small]: {marginTop: 0}})}
    {...args}
  />
);
